import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["PopularPosts"] */ "/app/src/ui/sections/blog/popular-posts/popular-posts.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/sections/blog/post-content/styles/post-content.scss");
;
import(/* webpackMode: "eager", webpackExports: ["PostHero"] */ "/app/src/ui/sections/blog/post-hero/post-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonBase"] */ "/app/src/ui/shared/ui/buttons/button-base.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonSimple"] */ "/app/src/ui/shared/ui/buttons/button-simple.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonWithImage"] */ "/app/src/ui/shared/ui/buttons/button-with-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CloseButton"] */ "/app/src/ui/shared/ui/buttons/close-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowMoreShowLessButton"] */ "/app/src/ui/shared/ui/buttons/show-more-show-less-button.tsx");
